module.exports = __webpack_public_path__ + "img/gz.722d8acb.png";